import ContentLayout from '../../components/ContentLayout/ContentLayout'
import ImageContainer from '../../components/ImageContainer/ImageContainer'
import ErrorContent from '../../components/ErrorContent/ErrorContent'

export default function ErrorFallbackPage() {
	return (
		<ContentLayout
			LeftSide={<ImageContainer src="/assets/images/error-house.png" width="60%" />}
			RightSide={
				<ErrorContent
					errorCode="500_error.code"
					errorHeader="500_error.header"
					errorMessage="500_error.message"
				/>
			}
		/>
	)
}
